export default {
  listFunctions: [],
  function: {
    ativo: true,
    id: 0,
    nome: '',
  },
}
